import {Box, Button, Container, Link, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {AppleLogoIcon} from "@phosphor-icons/react";
import Phone from "./Phone";

export default function Hero() {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));

    return (
        <Container
            maxWidth={"lg"}
        >
            <Box
                width={"100%"}
                height="100vh"
                display="flex"
                flexDirection="row"
                flexWrap={"wrap"}
                justifyContent="space-between"
                alignItems={"center"}
                id={"hero"}
            >
                <Box
                    width={matches ? "35%" : "100%"}
                    textAlign={"left"}
                >
                    <Typography variant={matches ? "h2" : "h4"} fontWeight={"bold"} component={"h1"}>
                        Make personal connections
                    </Typography>
                    <Box height={20}/>
                    <Typography variant={matches ? "h6" : "body1"} component={"p"}>
                        Post an ad about yourself. Get replies back. No photos needed.
                    </Typography>
                    <Box height={30}/>
                    <Button variant={"contained"} size={"large"} sx={{width: "100%", fontWeight: "bold"}}
                            startIcon={<AppleLogoIcon weight={"fill"}/>} component={Link}
                            href={"https://apps.apple.com/us/app/personally/id6758896687"}>
                        DOWNLOAD
                    </Button>
                </Box>
                <Box
                    width={matches ? "55%" : "100%"}
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    // need relative so phone positions absolute against this, for overflow to work
                    position={"relative"}
                    top={matches ? "12%" : 0}
                    left={matches ? "7%" : "40%"}
                >
                    <Phone/>
                </Box>
            </Box>
        </Container>
    );
}